import axios from 'axios';
import { snackbar } from '@/plugins/snackbar';
import bus from '@/utils/bus';
import CustomError from '@/utils/customError';
import {
  API_RESPONSE_STATUS,
  HTTP_STATUS,
  SNACKBAR_TYPES,
} from '@/utils/constants';

export default {
  install(Vue, { router, store }) {
    if (!router || !store) {
      throw new Error('Please initialize plugin with a Vuex store and Vue router.');
    }

    const service = axios.create({
      timeout: 10000,
    });

    service.interceptors.response.use((res = {}) => {
      const { data = {} } = res;
      if (data?.status === API_RESPONSE_STATUS.NORMAL) {
        return Promise.resolve(data);
      }
      return Promise.reject(data);
    }, (error) => {
      const { response = {} } = error;
      const { status } = response;
      if (status === API_RESPONSE_STATUS.NOT_WORKING) {
        return window.location.replace(`/${API_RESPONSE_STATUS.NOT_WORKING}`);
      }
      if (status === API_RESPONSE_STATUS.NOT_AUTH) {
        snackbar({
          type: SNACKBAR_TYPES.ERROR,
          title: 'Token已經過期',
          msg: '請重新登入。',
        });
        localStorage.clear();
        store.dispatch('reset');
        bus.$emit('CLEAR_TEMP_COMPANY_NAME');
        // TODO: User router.replace after router error fixed
        // return router.replace('/login');
        return window.location.replace('/login');
      }
      return Promise.reject(new CustomError(error));
    });

    const DEFAULT_API_VERSION = 1;
    const ENDPOINT_MAP = [
      null /* First version is `ENDPOINT_MAP[1]` :) */,
      'v1/client/frontend/' /* This version will be deprecated in the future */,
      'api/v1/client/',
    ];

    function api({
      method,
      url,
      version = DEFAULT_API_VERSION,
      overrideBaseUrl,
      data,
      attrs,
    }) {
      const finalToken = localStorage.getItem('_t');
      const apiKey = localStorage.getItem('_k');
      const baseURL = process.env.VUE_APP_API_URI;
      const options = {
        ...attrs,
        baseURL,
        headers: {
          'Content-Type': 'application/json',
        },
        method,
        url: overrideBaseUrl ? url : `${ENDPOINT_MAP[version]}${url}`,
      };
      const methods = [
        HTTP_STATUS.PATCH,
        HTTP_STATUS.POST,
        HTTP_STATUS.PUT,
      ];
      const methodToLower = method.toLowerCase();
      if (methodToLower === HTTP_STATUS.GET) {
        options.params = { ...data };
      } else if (methods.includes(methodToLower)) {
        options.data = data;
      }

      if (apiKey) {
        options.headers['x-api-key'] = apiKey;
      }
      if (finalToken) {
        options.headers.authorization = `Bearer ${finalToken}`;
      }

      return service(options);
    }

    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$api = () => ({
      del: ({
        url, version, data, attrs, overrideBaseUrl = false,
      }) => api({
        method: HTTP_STATUS.DELETE,
        url,
        version,
        overrideBaseUrl,
        data,
        attrs,
      }),
      get: ({
        url, version, data, attrs, overrideBaseUrl = false,
      }) => api({
        method: HTTP_STATUS.GET,
        url,
        version,
        overrideBaseUrl,
        data,
        attrs,
      }),
      patch: ({
        url, version, data, attrs, overrideBaseUrl = false,
      }) => api({
        method: HTTP_STATUS.PATCH,
        url,
        version,
        overrideBaseUrl,
        data,
        attrs,
      }),
      post: ({
        url, version, data, attrs, overrideBaseUrl = false,
      }) => api({
        method: HTTP_STATUS.POST,
        url,
        version,
        overrideBaseUrl,
        data,
        attrs,
      }),
    });
  },
};
